<template>
    <div>

        <el-row :gutter="20">
            <el-col :class="{'deleted':article.deleteYn === 'Y'}" :span="24">
                <el-card shadow="hover">
                <p class="fs18">
                    <span class="pull-right" v-if="boardMst.stateYn == 'Y'" :class="pickClass('stateList', article.state)">{{article.state}}</span> 
                    <span v-if="boardMst.categoryYn == 'Y'" class="mr-1" :class="pickClass('categoryList', article.category)">[{{article.category}}]</span> 
                    <span>{{ article.articleTitle }}</span> <i v-if="article.secretYn === 'Y'" class="ml-2 el-icon-lock text-warning font-weight-bold fs18"></i>
                </p>
                <p class="mt-3">
                    <span class="pull-right"><i class="text-medium-gray el-icon-time mr-1"></i> {{ article.createDt | moment('YYYY.MM.DD HH')}}</span>
                    <span><i class="text-medium-gray el-icon-user mr-1"></i> {{article.writerNm}}</span>
                    <span class="l-bar"><i class="text-medium-gray el-icon-message mr-1"></i> {{article.writerEmail}}</span>
                </p>
               
                </el-card>
            </el-col>
        </el-row>
        <el-row class="mt-3" :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div v-if="(articleAttach.length > 0)" class="attach-box mb-3 text-medium-gray"><i class="el-icon-files"></i> 첨부파일 
                        <span class="l-bar" v-for="item in articleAttach" :key="item.attachNo">
                            <a :href="download(item)"><i class="el-icon-paperclip"></i>  {{item.fileNm}}</a>
                        </span>
                    </div>

                    <div v-if="article.htmlYn === 'Y'" v-html="article.articleText"></div>
                    <pre v-if="article.htmlYn !== 'Y'">{{article.articleText}}</pre>
                </el-card>
            </el-col>
        </el-row>

        <el-card class="mt-3" shadow="hover">
          <el-form @submit.native.prevent="submitForm('ruleForm')" :model="article" :rules="rules" ref="ruleForm" label-width="120px" class="mt-3 mr-5">

            <!-- <p class="text-center mb-4 fs15 text-primary2">소속된 업체의 담당자만 가입이 가능합니다. 가입을 위해 소속업체를 선택하세요</p> -->
            <!-- <hr class=""/> -->

            <!-- <el-row >
                <el-col :span="12" v-if="boardMst.stateYn === 'Y'"  >
                    <el-form-item label="상태" prop="state" required>
                        <el-select class="w-100" v-model="article.state" >
                            <el-option v-for="item in this.boardMst.stateList"
                            :key="item.value" :label="item.value" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row> -->

            <el-row>
                <el-col :span="12">
                    <el-form-item label="답변 작성자" prop="replyNm" required>
                        <el-input  v-model="article.replyNm" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="답변자 이메일" required>
                    <el-col :span="11">
                    <el-form-item prop="emailId" required>
                        <el-input v-model="article.emailId" ></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col class="text-center" :span="2">@</el-col>
                    <el-col :span="11">
                    <el-form-item prop="emailDomain" >
                        <el-input v-model="article.emailDomain" ></el-input>
                    </el-form-item>
                    </el-col>
                </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="답변용 첨부파일" >
                <el-col :span="24">    
                    <el-card shadow="never">                
                        <el-upload
                        action=""
                        class="upload-demo"
                        :auto-upload="false"
                        multiple
                        :on-remove="onFileChange"
                        :on-change="onFileChange"
                        :before-remove="onFileBeforeRemove"
                        :file-list="replyAttach">
                        <el-button size="medium" type="primary">업로드할 파일 추가선택</el-button> <span class="ml-3 text-medium-gray"><i class="el-icon-info"></i> 여러개 추가선택이 가능. (한번에 올릴 수 있는 용량은 파일들을 합쳐서 20M이하만 가능.)</span>
                        <div slot="tip" >
                           <span class="fs15">( {{ attachSize | fileSize }} / 20MB )</span>
                        </div>
                        </el-upload>
                    </el-card>
                </el-col>

            </el-form-item>

            <vue-editor class="mt-3 ml-5 pb-5" style="height:500px" id="editor1" v-model="article.replyText" ></vue-editor>
            

        </el-form>    
        </el-card>

        <div class="mt-5 text-center" :gutter="20">
                <el-button @click="submitForm" type="primary" icon="el-icon-edit">답변 저장</el-button>
                <el-button class="ml-3" type="default" icon="el-icon-back" @click="gotoView">취 소</el-button>
        </div>

    </div>

</template>

<script>
import BoardProxy from '@/proxies/BoardProxy'
import PasswordModal from './PasswordModal'
import {VueEditor} from "vue2-editor";
import CommonProxy from '@/proxies/CommonProxy';
import * as Util from '@/util/util'
import _ from 'lodash'

const validator =({required, onlyWord, domain, min, confirmPassword, phone }, vm) => {

    return (rule, value, callback) => {
    
        if(required && !value) {
            callback( new Error('필수입력 항목입니다.'))
            return
        } else if(onlyWord && !/^[\w\-\.]+$/g.test(value) ) {
            callback( new Error('영문만 가능합니다.'))
            return
        } else if(domain && !/[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value) ) {
            callback( new Error('이메일 형식만 가능합니다. ex)gmail.com'))
            return
        } else if(min && value.length < min ) {
            callback( new Error(`최소 ${min}자리 이상 이어야 합니다.`))
            return
        } else if(confirmPassword && vm.article.password !== vm.article.confirmPassword ) {
            callback( new Error('비밀번호가 일치하지 않습니다.'))
            return
        } else if(phone  && !/^[\d\-]+$/g.test(value) ) {
            callback( new Error('숫자 또는 -(하이픈)만 가능합니다.'))
            return
        } else {
            callback()
        }
    
    }

} 

    
export default {
    components: {
        VueEditor
    },
    methods: {
        download( {articleNo, attachNo} ) {

            //location.href = "/api/advertiser/contract/" + row.contractSeq + "/download?authorization=" + $cookies.get('id_token');

            return `/api/board/${this.boardMst.boardNo}/download/${articleNo}/${attachNo}?authorization=${$cookies.get('id_token')}`
        },
        onFileBeforeRemove(file, fileList) {
            // 업로드 되어있는 파일 삭제
            if(file.attachNo) {
                if(!confirm(file.name+'\n\n지금 삭제클릭한 파일은 이미 서버에 업로드된 파일입니다.\n서버에서 삭제하시겠습니까?')) {
                    return false
                }
                // 삭제할 리스트에 담는다.
                this.removeAttachList.push(file.attachNo)
            }
            return true

        },
        onFileChange(file, fileList) {
            
            const sameItem = fileList.find(item=> item !== file && item.name === file.name && item.size === file.size)

            if(sameItem) {
                fileList.splice( fileList.indexOf(sameItem), 1 )
            }

            let size = 0
            fileList.forEach(file=>size += (file.size || file.fileSize) )

            if(size > 20000000) {
                alert('파일용량이 20M를 초과했습니다.')
                fileList.splice( fileList.indexOf(file), 1 )
            }
            this.replyAttach = [...fileList]

            this.setUploadSize()

        },
        setUploadSize() {
            
            let size = 0
            this.replyAttach.forEach(file=>size += (file.size || file.fileSize) )            
            this.attachSize = size           

        },
        async getArticle() {

            return new BoardProxy()
            .getArticle(this.boardNo, this.articleNo)
            .then(res=> {
                this.article = {...res.item}
                this.articleAttach = [...res.articleAttach]
                this.replyAttach = [...res.replyAttach]

                this.article.replyNm =  this.article.replyNm || this.$store.state.account.userName
                this.article.replyEmail =  this.article.replyEmail || this.$store.state.account.email

                this.article.state = (this.article.state === this.boardMst.defaultState ? this.boardMst.replyState : this.article.state )

                this.setUploadSize()

                return res;
            })

        },
        pickClass( dest, value ) {

            return (this.boardMst[dest].find(item=>item.value === value) || {}).cls

        },
        gotoView() {
            this.$router.push({
                name: 'ArticleView',
                params: {
                    boardNo: this.boardNo,
                    articleNo: this.articleNo
                },
                query: { ...this.$route.query }
            })
        },
        setEmail( value ) {
            console.log(value)
            this.article.replyEmail = `${this.article.emailId}@${this.article.emailDomain}`
        },
        parseEmail() {
            const tokens = this.article?.replyEmail?.split('@')
            if(tokens?.length > 1) {
                this.article = { ...this.article, emailId:tokens[0], emailDomain:tokens[1] }
            }
        },
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {

              if (valid) {

                if(!this.article.replyText) {
                    alert('답변 내용을 입력해 주세요')
                    return false;
                }

                const proxy = new BoardProxy()
                
                proxy
                .reply( this.article, this.replyAttach, this.removeAttachList )
                .then(response => {
                    if(response.header.returnCode !== 'OK') {
                        alert(response.header.resultMessages)
                    } else {

                        alert('답변이 등록 되었습니다.')

                        if(confirm('답변내용을 질문자의 이메일로 전송하시겠습니까?')) {
                            if(!this.article.writerEmail) {
                                alert('작성자의 이메일이 없습니다.');
                                this.gotoView();
                                return;
                            }
                            proxy.sendReplyMail( this.boardNo, this.articleNo )
                            .then((response)=>{

                                if (response.header.returnCode === "OK") {
                                    alert('답변메일을 전송했습니다.')
                                } else {
                                    alert(response.header.resultMessages);
                                }
                               
                                this.gotoView();
                            })
                        } else {

                            this.gotoView()

                        }    

                    }
                })

              } else {
                  alert('필수 항목들을 빠짐없이 입력해 주세요')
                  return false;
              }
            })
        }

    },
    created() {
        
        this.boardNo = this.$route.params.boardNo
        this.articleNo = this.$route.params.articleNo

        this.getArticle()
        .then(res=>{

            if(!this.article.canUpdate) {
                alert('잘못된 권한입니다.')
                this.$router.push({name:'ArticleList',params:this.boardNo})
            }

        })
        .then(this.parseEmail)

        
        
    },
    computed: {
        boardMst() {
            return this.$store.state.board.boardMst
        },

    },
    watch: {
        'article.emailId': 'setEmail',
        'article.emailDomain': 'setEmail',
    },
    data() {
        return {
            attachSize: 0,
            action: undefined,
            removeAttachList: [],
            articleAttach: [],
            replyAttach: [],
            article: {
            },
            rules: {
                emailId: [
                    { trigger: 'blur', validator: validator({ required: true, onlyWord: true }) },
                    { trigger: 'change', validator: validator({ required: true, onlyWord: true }) }
                ],
                emailDomain: [
                    { trigger: 'blur', validator: validator({ required: true, domain: true }) },
                    { trigger: 'change', validator: validator({ required: true, domain: true }) }
                ],
                state: [
                    { trigger: 'change', validator: validator({ required: true}) },
                ],
                replyNm: [
                    { trigger: 'blur', validator: validator({ required: true}) },
                    { trigger: 'change', validator: validator({ required: true}) },
                ],

            },
        }
    }

}
</script>

<style lang="scss" >
</style>

<style scoped>
.bb {border-bottom:1px dotted #eee;}
.attach-box {border-bottom:1px dotted #eee; padding-bottom:10px;}
.deleted * {text-decoration: line-through;} 
.el-form-item {
    margin-bottom: 22px !important;
}
</style>